<mat-form-field appearance="outline" class="full-width" style="width: 100%; display: block;">
  <input type="text" matInput [placeholder]="placeholder" class="form-control" [(ngModel)]="phoneNumber"
    (ngModelChange)="onUpdate($event)">
</mat-form-field>
<div class="error-msg" *ngIf="errorMsg && dirty">{{errorMsg}}</div>